import { render, staticRenderFns } from "./privateLogin.vue?vue&type=template&id=5175040f&scoped=true&"
import script from "./privateLogin.vue?vue&type=script&lang=ts&"
export * from "./privateLogin.vue?vue&type=script&lang=ts&"
import style0 from "./privateLogin.vue?vue&type=style&index=0&id=5175040f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5175040f",
  null
  
)

export default component.exports